import { useState, useCallback } from 'react';
import api from '../api/client';

const useSearchURL = () => {
  const [isBuscando, setBuscando] = useState(false);
  const [erroresSearch, setErrorSearch] = useState(null);

  const searchData = useCallback(async (path, datos, usarDatos) => {
    setBuscando(true);
    setErrorSearch(null);
    try {
      const res = await api.post(path, datos);
      if (res.ok) {
        usarDatos(res.data ?? []);
      } else {
        setErrorSearch(res.errors ?? ['Error en la búsqueda']);
        usarDatos([]);
      }
    } catch (error) {
      setErrorSearch(['Error en la búsqueda: ' + (error.message ?? error)]);
      usarDatos([]);
    }
    setBuscando(false);
  }, []);

  const resetErroresSearch = () => {
    setErrorSearch(null);
  };

  return { isBuscando, erroresSearch, searchData, resetErroresSearch };
};

export default useSearchURL;
